// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"51e8551f","112":"a0328bc4","207":"895fa746","228":"062facfb","453":"39edb0bf","669":"8e55bbe6","695":"44784923","739":"7a7b836c","820":"edfd3db3"}[chunkId] + ".chunk.js";
};